import { useLazyPromise } from "@codesandbox/states";
import { usePitcher } from "features/utils/usePitcher";

export const usePitcherResetLocalToRemote = () => {
  const pitcher = usePitcher();

  return useLazyPromise(() => pitcher.clients.git.resetLocalWithRemote());
};
